const component = {
  template: `
    <div class="singleLogo">

      <img ng-if="!$ctrl.cause.subentity" class="singleLogo__logo" ng-src="//cdn.startupmedia.com/greenback/entities/{{$ctrl.id}}/logo.png">

      <img ng-if="$ctrl.cause.subentity" class="singleLogo__logo" ng-src="//cdn.startupmedia.com/greenback/entities/{{$ctrl.id}}/{{$ctrl.cause.subentity.id}}/logo.png" default-sponsor-logo="//cdn.startupmedia.com/greenback/entities/{{$ctrl.id}}/logo.png">

    </div>
  `,
  bindings: {
    id: '@',
    entityType: '@',
    headerTxt: '@',
    isFull: '@',
    cause: '<',
    gradient: '<'
  },
  controller() {
    this.$onInit = () => {
    };
  }
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/singleLogo/index.js